import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setupToast } from '../../../store/toast/action';
import { toggleWatchList } from '../../../store/watch-list/action';
import AuctionCard from './component';

const mapStateToProps = ({ user }) => ({ user });

const mapDispatchToProps = (dispatch) => bindActionCreators({
    toggleWatchListConnect: toggleWatchList,
    setupToastConnect: setupToast
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AuctionCard);